import { Download, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface PolicyExportButtonProps {
  selectedIds: Set<string>
  onExportSelected: () => void
  onExportAll: () => void
  isExporting: boolean
}

export function PolicyExportButton({
  selectedIds,
  onExportSelected,
  onExportAll,
  isExporting,
}: PolicyExportButtonProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={isExporting} className="h-8">
          {isExporting ? (
            <Loader2 className="mr-2 h-3.5 w-3.5 animate-spin" />
          ) : (
            <Download className="mr-2 h-3.5 w-3.5" />
          )}
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={onExportSelected}
          disabled={selectedIds.size === 0}
        >
          Export Selected ({selectedIds.size})
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onExportAll}>
          Export All
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
